import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=412b7aaa&scoped=true"
import script from "./Detail.ts?vue&type=script&lang=ts&external"
export * from "./Detail.ts?vue&type=script&lang=ts&external"
import style0 from "./Detail.vue?vue&type=style&index=0&id=412b7aaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412b7aaa",
  null
  
)

export default component.exports